export const selectionwedAlbumsData = state => state.album.onwedAlbums.data;
export const currentPageNo = state => state.album.onwedAlbums.pageNo;
export const captionSortAlbumsData = state => state.album.captionSortAlbums.data;
export const individualAlphabetCacheResponse = state => state.album.captionSortAlbums.individualAlphabetCache
export const selectedAlbumData = state => state.album.allAlbumPicInfo.selectedAlbums.data;
export const getAlbumSpecificData = (selectedAlbumsData, albumId) => selectedAlbumsData.albumId;
export const mySharedAlbumsData = state => state.album.mySharedAlbums.data;
export const myFriendsAlbumsData = state => state.album.myFriendsAlbums.data;
export const unSelectedAlbumsData = state => state.album.allAlbumPicInfo.unSelectedAlbums.currentUnselectedAlbumPicInfo
export const showViewLessButton = state => state.album.albumView.showViewLess;
export const albumThumnailSize = 200;
export const timeZoneOffset = new Date().getTimezoneOffset() * -1;
export const clustersPerPage = 5;
export const pagesToLoad = 2;
export const sharedAlbumsLimit = 25;
export const captionSortMinimumLimit = 9;
export const captionLetterSpecificCollectionListLimit = 50;

export const getAlbumThumnailSize = () => {
    try {
        const thumbnailAvailableSizes = photoOrg.Util.thumbnailAvailableSizes
        let albumThumnailSize = thumbnailAvailableSizes[0];
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (windowWidth > 1024 && windowWidth <= 1920) {
            albumThumnailSize = thumbnailAvailableSizes[1];
        }
        else if (windowWidth > 1920) {
            albumThumnailSize = thumbnailAvailableSizes[2];
        }
        return albumThumnailSize;
    } catch (e) {
        photoOrg.clientLogger.error({description: "LIBRARY:albums_view:getAlbumThumnailSize:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
    }
}

